/*
 * @author Sanford Whiteman
 * @version v1.106 2020-04-04
 * @copyright © 2020 Sanford Whiteman
 * @license Hippocratic 2.1: This license must appear with all reproductions of this software.
 *
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
function destyleMktoForm(mktoForm, moreStyles) {
  let formEl = mktoForm.getFormElem()[0],
    arrayFrom = getSelection.call.bind([].slice);

  // remove element styles from <form> and children
  let styledEls = arrayFrom(formEl.querySelectorAll('[style]')).concat(formEl);
  styledEls.forEach(el => {
    el.removeAttribute('style');
  });

  // disable remote stylesheets and local <style>s
  let styleSheets = arrayFrom(document.styleSheets);
  styleSheets.forEach(ss => {
    let list = [];
    if (typeof mktoForms2BaseStyle !== 'undefined') list.push(mktoForms2BaseStyle);
    if (typeof mktoForms2ThemeStyle !== 'undefined') list.push(mktoForms2ThemeStyle);
    if (list.indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
      //console.log('Marketo destyle: removing', ss);
      ss.disabled = true;
      //console.log(ss);
      ss.ownerNode.parentNode.removeChild(ss.ownerNode);
    } else {
      //console.log('Marketo destyle: ignoring', ss);
    }
  });

  if (!moreStyles) {
    formEl.setAttribute('data-styles-ready', 'true');
  }
}

function improveMktoLabelRef(form) {
  /* util */
  let arrayify = getSelection.call.bind([].slice);

  let formEl = form.getFormElem()[0],
    rando = '_' + new Date().getTime() + Math.random();

  arrayify(formEl.querySelectorAll('label[for]'))
    .map(labelEl => {
      return {
        label: labelEl,
        for: formEl.querySelector('[id="' + labelEl.htmlFor + '"]'),
      };
    })
    .forEach(labelDesc => {
      if (labelDesc.for) {
        if (!labelDesc.for.hasAttribute('data-uniquified')) {
          labelDesc.for.id = labelDesc.for.id + rando;
          labelDesc.for.setAttribute('data-uniquified', 'true');
        }
        labelDesc.label.htmlFor = labelDesc.for.id;
      }
    });
}

function addMktoFormClasses(form) {
  let $buttons = form.getFormElem().find('button');
  for (let i = 0; i < $buttons.length; i++) {
    $buttons[i].classList.add('button');
  }
}

MktoForms2.whenRendered(function (form) {
  destyleMktoForm(form);

  improveMktoLabelRef(form);
  addMktoFormClasses(form);
});

class MarketoForm extends HTMLElement {
  formID = false;
  formEl = false;
  mktoFormConfig = {
    podId: '//237-RBJ-385.mktoweb.com',
    munchkinId: '237-RBJ-385',
  };
  #preventDefaultFormSubmit = false;
  redirectUrl = false;
  completeMessage = false;
  completeCookieName = false;

  constructor() {
    super();

    this.formEl = this.querySelector('form');

    this.formID = this.formEl.getAttribute('data-formid');

    let podID = this.getAttribute('data-podid');
    let munchkinID = this.getAttribute('data-munchkinid');
    if (podID) this.mktoFormConfig.podId = podID;
    if (munchkinID) this.mktoFormConfig.munchkinId = munchkinID;

    let redirectUrl = this.getAttribute('data-redirect-url');
    if (redirectUrl) this.redirectUrl = redirectUrl;
    let completeMessage = this.getAttribute('data-complete-message');
    if (completeMessage) this.completeMessage = completeMessage;

    let completeCookieName = this.getAttribute('data-complete-cookie-name');
    if (completeCookieName) this.completeCookieName = completeCookieName;

    if (redirectUrl || completeMessage) {
      this.preventDefaultFormSubmit = true;
    }
  }

  initializeEvents() {}

  connectedCallback() {
    if (this.hasAttribute('data-processed')) return;
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  loadForm(callback = () => {}) {
    if (this.formID) {
      let mktoLoadForm = MktoForms2.loadForm.bind(
        MktoForms2,
        this.mktoFormConfig.podId,
        this.mktoFormConfig.munchkinId,
        this.formID,
      );

      this.formEl.id = 'mktoForm_' + this.formID;

      mktoLoadForm(form => {
        this.formEl.id = '';
        this.setAttribute('data-processed', true);

        if (form !== null && typeof form.onSuccess === 'function') {
          form.onSuccess(() => {
            this.onFormSubmit();
            if (this.preventDefaultFormSubmit) {
              return false;
            }
          });
        } else {
          this.innerHTML = 'There was an error loading this form.';
        }

        callback();
      });
    } else {
      callback();
    }
  }

  set preventDefaultFormSubmit(value) {
    this.#preventDefaultFormSubmit = value;
  }

  get preventDefaultFormSubmit() {
    return this.#preventDefaultFormSubmit;
  }

  onFormSubmit() {
    this.dispatchEvent(
      new CustomEvent('complete', {
        bubbles: true,
        composed: true,
        detail: {
          formId: this.formID,
          formEl: this.formEl,
        },
      }),
    );

    // Custom analytics tracking
    if (typeof dataLayer != 'undefined') {
      dataLayer.push({
        event: 'eventTracking',
        eventTrackingCategory: 'marketoForm',
        eventTrackingAction: 'submit',
        eventTrackingLabel: this.formID,
      });
      console.log('tracking marketo form conversion');
    }
    if (typeof fbq != 'undefined') {
      fbq('track', 'Lead');
    }

    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    } else if (this.completeMessage) {
      this.formEl.innerHTML = this.completeMessage;
    }

    if (this.completeCookieName) {
      let date = new Date();
      date.setTime(date.getTime() + 60 * 60 * 24 * 30 * 1000); // 30 days
      // Set the cookie
      document.cookie =
        this.completeCookieName + '=true; expires=' + date.toUTCString() + '; path=/';
    }
  }
}

customElements.define('marketo-form', MarketoForm);

// Loop through forms, one at a time, load form, then move to next
function mktoLoadChain(formList) {
  let form = formList.shift();
  if (form) {
    form.loadForm(() => {
      if (formList.length) mktoLoadChain(formList);
    });
  }
}

mktoLoadChain(getSelection.call.bind([].slice)(document.querySelectorAll('marketo-form')));
